import _isEmpty from 'lodash/isEmpty';

import { multiCaseGet } from 'libs/format';

export function getLayoutComponents(layouts, componentFastIds) {
  if (_isEmpty(layouts)) {
    return [];
  }

  // Add layout index, component index, and reduce across layouts
  return layouts
    .map((layout, layoutIndex) => {
      const newLayout = {
        ...layout,
        components: layout.components || [],
      };
      newLayout.components = newLayout.components.map((component, index) => {
        return {
          ...component,
          layoutIndex,
          index,
        };
      });
      return newLayout;
    })
    .reduce((acc, layout) => [...acc, ...layout.components], [])
    .filter((component) => {
      const fastId = multiCaseGet(component, 'fastId');
      return componentFastIds.includes(fastId);
    });
}
